import r from"./_baseGet.js";var a=r;var o=function(r,o,t){var e=null==r?void 0:a(r,o);return void 0===e?t:e};export{o as default};
//# sourceMappingURL=get.js.map
